import isFunction from "lodash/isFunction";


export default (data => {
  if (!isFunction(window.jsHostQuery)) {
    return;
  }

  return window.jsHostQuery({
    request: JSON.stringify(data),
    persistent: false,
    onSuccess: () => {},
    onFailure: () => {}
  });
});